import ACTION_TYPES from 'annuity_lab/tools/mad/actions/action_types.js';
import {_updateProductContext} from 'annuity_lab/tools/common/actions/product_context.js';

export function updateProductContext(money, deferralPeriod) {
    return _updateProductContext(money, deferralPeriod, ACTION_TYPES);
}
